// The support mailbox, for the surfaces that link to it directly with a
// `mailto:` (the membership tab and the crash page).
export const SUPPORT_EMAIL = "support@nara.com";
